import { Form, FormInstance, Input, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Footer from '../../../../components/Popup/_components/Footer';
import { callEventPopup } from '../../../../contexts/PopupContext';
import { createDashboardFetch, updateDashboardFetch } from '../../../../util/services/dashboard';
import { useSelector } from '../../../../util/store/store';
import { ACTION_TYPE } from "../../../../util/varibles/constants";
import { showErrorResponse } from '../../../../util/varibles/global';
import { NotifyCode, notify } from '../../../../util/varibles/message';
import { WIDGET_TYPE, initSensors } from '../../constants';
import { vesselDetailActions } from '../../reducer';
import GaugeComponent from './GaugeComponent';
import LineChartComponent from './LineChartComponent';
import TankComponent from './TankComponent';
import styles from "./style.module.scss";

const widgetTypes = [
    { label: 'Gauge', value: WIDGET_TYPE.GAUGE },
    { label: 'Line chart', value: WIDGET_TYPE.LINE },
    // {label: 'Tank', value: WIDGET_TYPE.TANK}
];

interface IProps {
    widget: any
    editMode: ACTION_TYPE
}

const PopupEditWidget: React.FC<IProps> = (props) => {
    const { widget, editMode } = props;
    const formRef = useRef<FormInstance>(null);
    const [loading, setLoading] = useState(false);
    const { onClose } = callEventPopup();
    const dashboard = useSelector(state => state.vesselDetail.dashboard);
    const vessel = useSelector(state => state.vesselDetail.vessel);
    const devices = useSelector(state => state.vesselDetail.devices);
    const dispatch = useDispatch();

    useEffect(() => {
        if (formRef.current && widget) {
            const { widgetType, devices = [], sensors = [] } = widget;
            if (widgetType === WIDGET_TYPE.LINE) {
                const devicesOrigin: any = [];
                const sensorsOrigin: any = [];
                const sensorsValue: any = [];
                devices.reduce((list: any, device: any) => {
                    devicesOrigin.push(JSON.stringify(device));
                    device.sensors.forEach((sensor: any) => {
                        if (!list[sensor.name])
                            list[sensor.name] = 1;
                        else
                            list[sensor.name]++;
                        if (list[sensor.name] === devices.length)
                            sensorsOrigin.push(sensor)
                    })
                    return list;
                }, {})
                if (sensorsOrigin.length === 0 || sensors.length === 0) {
                    formRef.current.setFieldsValue({ ...widget, ...initSensors, devices: devicesOrigin })
                } else {
                    const isCheck = sensors.some((item: any) => {
                        const { name } = item;
                        sensorsValue.push(JSON.stringify(item));
                        return !sensorsOrigin.find((sensorData: any) => sensorData.name === name)
                    })
                    if (isCheck)
                        formRef.current.setFieldsValue({ ...widget, ...initSensors, devices: devicesOrigin })
                    else
                        formRef.current.setFieldsValue({
                            ...widget,
                            devices: devicesOrigin,
                            sensors: sensorsValue,
                        })
                }
            } else {
                const sensorsOrigin = devices[0].sensors;
                if (sensorsOrigin.length === 0 || sensors.length === 0) {
                    formRef.current.setFieldsValue({
                        ...widget, ...initSensors, devices: JSON.stringify(devices[0])
                    })
                } else {
                    const isCheck = sensorsOrigin.findIndex((sensorData: any) => sensorData.name === sensors[0].name) === -1
                    if (isCheck)
                        formRef.current.setFieldsValue({
                            ...widget, ...initSensors, devices: JSON.stringify(devices[0])
                        })
                    else
                        formRef.current.setFieldsValue({
                            ...widget,
                            sensors: JSON.stringify(sensors[0]),
                            devices: JSON.stringify(devices[0])
                        })
                }
            }
        }
    }, [formRef, widget]);

    const handleSubmit = (values: any) => {
        let { devices = [], sensors = [], widgetType, yAxis = [] } = values;
        let data: any;
        let params: any[] = [], keys: any = [];
        if (widgetType === WIDGET_TYPE.LINE) {
            sensors = sensors.map((item: any) => JSON.parse(item));
            devices = devices.map((item: any) => {
                const device = JSON.parse(item);
                const { device_id, device_name } = device;
                params = [...params, ...sensors.reduce((listSensors: any, { name, unit }: any) => {
                    const yAxisIndex = yAxis.findIndex(({ format }: any) => format === unit);
                    keys.push({ device_id, device_name, sensor: name, yAxis: yAxisIndex !== -1 ? yAxisIndex : 0 });
                    return [...listSensors, { device_id, sensor: name }]
                }, [])]
                return device;
            });

        } else {
            devices = [JSON.parse(devices)];
            sensors = [JSON.parse(sensors)];
            const { device_id, device_name } = devices[0];
            const { name } = sensors[0];
            keys = [{ device_id, device_name, sensor: name, yAxis: 0 }]
            params = [{ device_id, sensor: name }]
        }
        yAxis = yAxis.map((item: any) => {
            const { min, max } = item;
            return { ...item, min: min && min.length > 0 ? min : 0, max: max && max.length > 0 ? max : null }
        })
        data = { ...values, devices, sensors, keys, yAxis }
        dispatch(vesselDetailActions.getCurrentSensorDataRequest(params));
        if (dashboard) {
            const content = JSON.parse(dashboard.content);
            if (editMode === ACTION_TYPE.EDIT)
                content.splice(widget.index, 1, { ...data })
            else
                content.push({ ...data })

            handleSend(updateDashboardFetch, {
                ...dashboard,
                content: JSON.stringify([...content])
            }, (rs: any) => {
                dispatch(vesselDetailActions.updateDashboard({ dashboard: rs }))
            }, NotifyCode.S2, 'Create', data.name)
        } else {
            handleSend(createDashboardFetch, {
                vessel_id: vessel.id,
                is_default: true,
                content: JSON.stringify([{ ...data }])
            }, (rs: any) => {
                dispatch(vesselDetailActions.createDashboard({ dashboard: rs }))
            }, NotifyCode.S1, 'Update', data.name)
        }
    };

    const handleSend = (fetch: any, data: any, handleResponse: Function, code: NotifyCode, message: string, name: string) => {
        setLoading(true);
        fetch(data)
            .then((rs: any) => {
                onClose();
                handleResponse(rs);
                notify.success(code)([name])
                setLoading(false);
            })
            .catch((error: any) => {
                setLoading(false);
                showErrorResponse(message + ' failed', error)
            })
    }

    const renderContent = (widgetType: WIDGET_TYPE) => {
        const common = { devices, formRef: formRef };
        switch (widgetType) {
            case WIDGET_TYPE.GAUGE:
                return <GaugeComponent {...{ ...common }} />
            case WIDGET_TYPE.TANK:
                return <TankComponent />
            case WIDGET_TYPE.LINE:
                return <LineChartComponent {...{ ...common }} />
            default:
                return <LineChartComponent {...{ ...common }} />
        }
    }

    const handleChangeWidgetType = (widgetType: WIDGET_TYPE) => {
        const devices = formRef.current?.getFieldValue('devices');
        const isArray = Array.isArray(devices);
        if (widgetType === WIDGET_TYPE.LINE && !isArray)
            formRef.current?.setFieldsValue({ devices: devices ? [devices] : [] })
        else if (widgetType !== WIDGET_TYPE.LINE && isArray)
            formRef.current?.setFieldsValue({ devices: devices[0] })
    }

    return <Form {...{
        ref: formRef,
        onFinish: handleSubmit,
        name: 'vessel',
        layout: 'vertical',
        requiredMark: 'optional'
    }}>
        <div className={styles['modal-body']}>
            <Form.Item label="Widget type" name="widgetType" rules={[{ required: true }]}>
                <Select
                    className='h-[36px] select-single'
                    placeholder='Select a widget type'
                    onChange={handleChangeWidgetType}
                    options={widgetTypes}
                />
            </Form.Item>
            <Form.Item label="Widget name" name="name" rules={[{ required: true }]}>
                <Input placeholder='Widget name' />
            </Form.Item>
            <Form.Item noStyle
                shouldUpdate={(prev: any, current: any) => prev.widgetType !== current.widgetType}>
                {({ getFieldValue }: any) => renderContent(getFieldValue('widgetType'))}
            </Form.Item>
        </div>
        <Footer className={styles.footer} cancel={{ click: onClose }} ok={{ loading }} />
    </Form>;
};

export default PopupEditWidget;
